import { render, staticRenderFns } from "./Pagenation.vue?vue&type=template&id=6bfcef4c&"
import script from "./Pagenation.vue?vue&type=script&lang=ts&"
export * from "./Pagenation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports